import React from "react";
import Input from "../../../component/common/Input";
import Button from "../../../component/common/Button";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { useUser } from "../../../context/UserContext";
import httpServices from "../../../services/httpServices";
import CryptoJS from 'crypto-js';

// Define the Yup validation schema
const schema = yup.object().shape({
  password: yup
    .string()
    .required("Current Password is required")
    .min(8, "Password must be at least 8 characters long"),
  emailId: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
});

const Password = () => {
  const { user } = useUser();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const checkCredentials = async (data) => {
    try {

      const hashedPassword = CryptoJS.MD5(data.password).toString(CryptoJS.enc.Base64);

      const { response, error } = await httpServices.post("/users/login", {
        password: hashedPassword,
        emailId: data?.emailId,
      });

      if (error) {
        throw error;
      }
      if (response?.status === 200) {
        return true;
      }
    } catch (error) {
      toast.error("Current password is incorrect");
      return false;
    }
  };

  const onSubmit = async (data) => {
    console.log("Data", data);
    if (checkCredentials(data)) {
      const toastId = toast.loading("Sending link...");
      try {
        const { response } = await httpServices.post(`/users/send/link`, {
          emailId: data.emailId,
          redirectUrl: "http://localhost:3000/change-password",
        });
        if (response.status === 200) {
          console.log("Response", response.data?.link);
          toast.update(toastId, {
            render: "Reset Password link sent successfully!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
        }
      } catch (error) {
        toast.update(toastId, {
          render: error?.message || "Failed to send reset password link.",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      } finally {
        toast.dismiss(toastId);
      }
    }
  };

  return (
    <div className="px-2.5 xs:px-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap items-center gap-4">
          <div>
            <Input
              label="Current Password"
              {...register("password")}
              placeholder="Enter your current password"
              inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#71717A]"
              lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
              classes="w-full md:w-[400px]"
              type="password"
            />
            {errors.password && (
              <p className="text-red-500 text-sm">{errors.password.message}</p>
            )}
          </div>
          <div>
            <Input
              label="Email"
              {...register("emailId")}
              placeholder="Enter email ID"
              inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B] placeholder:text-[#71717A]"
              lableClasses="text-sm lg:text-[16px] !text-[#06152B]"
              classes="w-full md:w-[400px]"
            />
            {errors.emailId && (
              <p className="text-red-500 text-sm">{errors.emailId.message}</p>
            )}
          </div>
        </div>

        <Button
          classes="bg-[#2EDB72] py-3 px-[27px] mt-8"
          content="Send Link"
          type="submit"
        />
      </form>
    </div>
  );
};

export default Password;
